// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import 'core-js/es6/promise'
//import 'core-js/es6/string'
//import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'

import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';  // optional if you have css loader
import 'vue-loading-overlay/dist/vue-loading.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'vue2-datepicker/index.css';
import 'font-awesome/css/font-awesome.css';
//import 'bootstrap/scss/bootstrap.scss';

import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue'
import Toastr from 'vue-toastr';
import Services from './utils/services';
import select2 from '@/components/Select2'
import bgrid from '@/components/BGrid'
import bgridtree from '@/components/BGridTree'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import UnitTree from '@/components/UnitTree'
import TopLevelUnit from '@/components/TopLevelUnit'
import SyncDataSource from '@/components/SyncDataSource'
import RegionTree from '@/components/RegionTree'
import moment from 'moment';
import VueMoment from 'vue-moment'
import Vuelidate from 'vuelidate'
import Loading from 'vue-loading-overlay';
import Treeselect from '@riophae/vue-treeselect'
import './utils/common'
import DatePicker from 'vue2-datepicker';
import CSidebarNavDropdown2 from '@/components/CSidebarNavDropdown2';
import TextareaAutosize from 'vue-textarea-autosize'
import InputAutoSize from '@/components/InputAutoSize'
import JsonViewer from '@/components/JsonViewer'
import SyncUnitType from '@/components/SyncUnitType'
import ModalChangePassword from '@/components/ModalChangePassword'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import DocumentEditor from '@/components/DocumentEditor'
import VueNumeric from 'vue-numeric'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';


Vue.config.performance = true


//require("expose-loader?$!jquery");
//require('vue-toastr/dist/vue-toastr.min.css');

Vue.use(VueMoment, { moment });
Vue.use(Toastr, {
    defaultPosition: 'toast-bottom-right',
    closeButton: true
});
Vue.use(CoreuiVue)
Vue.use(BootstrapVue)
Vue.prototype.$services = Services;
Vue.use(Vuelidate);
Vue.use(Loading);
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(TextareaAutosize);
Vue.use(CKEditor);
Vue.use(VueNumeric)

Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)
Vue.component('select2', select2);
Vue.component('BGrid', bgrid);
Vue.component('BGridTree', bgridtree);
Vue.component('UnitTree', UnitTree);
Vue.component('TopLevelUnit', TopLevelUnit);
Vue.component('SyncDataSource', SyncDataSource);
Vue.component('RegionTree', RegionTree);
Vue.component('treeselect', Treeselect);
Vue.component('CSidebarNavDropdown2', CSidebarNavDropdown2);
Vue.component('InputAutoSize', InputAutoSize);
Vue.component('JsonViewer', JsonViewer);
Vue.component('SyncUnitType', SyncUnitType);
Vue.component('ModalChangePassword', ModalChangePassword);
Vue.component('DocumentEditor', DocumentEditor);

function checkValue(str, max) {
    if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
    };
    return str;
};
DatePicker.methods.handleInputKeydown = function (e) {
    var element = e.target;

    element.type = 'text';
    var input = element.value;
    var key = e.keyCode || e.charCode;

    if (key == 8 || key == 46)    // here's where it checks if backspace or delete is being pressed
        return false;

    if (/\D\/$/.test(input)) input = input.substr(0, input.length - 1);
    var values = input.split('/').map(function (v) {
        return v.replace(/\D/g, '')
    });
    if (values[0]) values[0] = checkValue(values[0], 31);
    if (values[1]) values[1] = checkValue(values[1], 12);
    var output = values.map(function (v, i) {
        return v.length == 2 && i < 2 ? v + '/' : v;
    });
    element.value = output.join('').substr(0, 10);

    var keyCode = e.keyCode; // Tab 9 or Enter 13

    if (keyCode === 9) {
        this.closePopup();
    } else if (keyCode === 13) {
        this.handleInputChange();
    }
}
DatePicker.props.valueType.default = 'YYYY-MM-DD';
DatePicker.props.format.default = function _default() {
    var map = {
        date: 'DD/MM/YYYY',
        datetime: 'DD/MM/YYYY HH:mm:ss',
        year: 'YYYY',
        month: 'MM/YYYY',
        time: 'HH:mm:ss',
        week: 'w'
    };
    return map[this.type] || map.date;
};
Vue.component('datePicker', DatePicker);

Vue.filter('formatDate', function (value, format) {
    if (value) {
        format = format || 'DD/MM/YYYY';
        return moment(String(value)).format(format);
    }
});

Vue.filter('formatTime', function (value, format) {
    if (value) {
        format = format || 'DD/MM/YYYY HH:mm:ss';
        return moment(String(value)).format(format);
    }
});

Vue.filter('formatNumber', function (value) {
    if (value && !isNaN(value)) {
        return value.toLocaleString('vi-VN', { maximumFractionDigits: 2 })
    }
    return value;
})

Vue.filter('currency', function (value) {
    if (value && !isNaN(value)) {
        return value.toLocaleString('vi-VN', { maximumFractionDigits: 2 }) + ' ₫';
    }
    return value;
})

Vue.filter('percentage', function (value) {
    if (value && !isNaN(value)) {
        return (value * 100).toLocaleString('vi-VN', { maximumFractionDigits: 2 }) + ' %';
    }
    return value;
})


store.dispatch("loadIdentity").then(function () {
    new Vue({
        el: '#app',
        router,
        store,
        icons,
        template: '<App/>',
        components: {
            App,
        },
        mounted() {
            //store.dispatch('initializeSettings');
            var self = this;
            $(document).ajaxSend(function (event, jqXHR, options) {
                if (options.async && options.showLoading != false) {
                    let loader = self.$loading.show({
                        container: options.formContainer,
                        canCancel: true,
                    });

                    jqXHR.always(function () {
                        loader.hide();
                    });
                }
            });
        }
    });
})
